import { useEffect, useSyncExternalStore } from "react";
import { api } from "@/lib/api";
import { formatPrice } from "@/lib/store";

// Taxas da maquininha (crédito 1x a 21x, em %). O lojista edita no admin; estes valores valem até a API responder.
export const DEFAULT_RATES = [3.31, 7.18, 8.56, 9.44, 10.31, 11.17, 12.0, 12.5, 12.55, 12.58, 12.61, 12.66, 13.3, 13.94, 14.58, 15.22, 15.86, 16.5, 17.14, 17.78, 18.42];

let rates = DEFAULT_RATES;
let loading = null;
const subs = new Set();

export const setRates = (list) => {
  if (!Array.isArray(list) || list.length !== 21) return;
  rates = list.map((r) => Number(r) || 0);
  subs.forEach((f) => f());
};

const loadRates = () => {
  if (!loading) loading = api.get("/card-rates").then((r) => setRates(r?.data?.rates)).catch(() => { loading = null; });
  return loading;
};

const subscribe = (f) => {
  subs.add(f);
  return () => subs.delete(f);
};

export const useRates = () => {
  useEffect(() => { loadRates(); }, []);
  return useSyncExternalStore(subscribe, () => rates);
};

// A taxa é repassada ao cliente para a loja receber o preço cheio: total = preço ÷ (1 − taxa).
export const installmentFor = (price, n) => {
  const rate = (rates[n - 1] ?? 0) / 100;
  const totalCents = Math.round((Number(price) * 100) / (1 - rate));
  return { total: totalCents / 100, each: Math.round(totalCents / n) / 100, rate: rates[n - 1] ?? 0 };
};

export const PLANS = [
  { id: "12x", n: 12 },
  { id: "21x", n: 21 },
];

export const planValues = (price, plan) => installmentFor(price, plan.n);

export const productPlans = (p) => (Number(p?.price) > 0 ? PLANS.filter((pl) => (p?.installments || []).includes(pl.id)) : []);

// Texto curto de parcelamento: maior plano marcado, ou o texto livre antigo do produto.
export const installmentText = (p) => {
  const plans = productPlans(p);
  if (plans.length) {
    const pl = plans[plans.length - 1];
    return `${pl.n}x de ${formatPrice(planValues(p.price, pl).each)}`;
  }
  return p?.installment ? p.installment.replace(/^ou\s+/i, "") : "";
};

export const promoOf = (p) => {
  const old = Number(p?.old_price);
  const now = Number(p?.price);
  return old > now && now > 0 ? { old, pct: Math.round((1 - now / old) * 100) } : null;
};
